<template>
    <pop-form v-if="state" width="900px" bodyMaxHeight="520px">
        <div slot="title">
            会员调账
        </div>
        <div class="user-info">
            <el-row type="flex" class="head">
                <el-col :span="4">姓名</el-col>
                <el-col :span="4">联系电话</el-col>
                <el-col :span="3">会员等级</el-col>
                <el-col :span="3">折扣</el-col>
                <el-col :span="3">有效时间</el-col>
                <el-col :span="2">卡项</el-col>
                <el-col :span="3">积分</el-col>
                <el-col :span="2">余额</el-col>
            </el-row>
            <el-row type="flex" class="data" v-show="storeUser.store_uid">
                <el-col :span="4">{{storeUser.name ? storeUser.name : "无"}}</el-col>
                <el-col :span="4">{{storeUser.mobile ? storeUser.mobile : "无"}}</el-col>
                <el-col :span="3">
                    <span>
                        {{storeUser.vip_name ? storeUser.vip_name : "无"}}
                    </span>
                </el-col>
                <el-col :span="3">{{storeUser.discount ? storeUser.discount : "无"}}</el-col>
                <el-col :span="3">
                    {{storeUser.vip_expire ? storeUser.vip_expire : "永久"}}
                </el-col>
                <el-col :span="2">
                    <span v-if="storeUser.card_num > 0">{{storeUser.card_num}}</span>
                    <span v-else>无</span>
                </el-col>
                <el-col :span="3">
                    {{storeUser.score}}
                </el-col>
                <el-col :span="2">
                    <span class="red">{{storeUser.money}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="blank10"></div>
        <div class="change-box">
            <el-row type="flex" class="head">
                <el-col :span="24">余额信息</el-col>
            </el-row>
            <el-row type="flex" class="data">
                <el-col :span="8" class="data-col">
                    <div class="label">会员余额</div>
                    <div class="value">
                        <el-input v-model="formData.money" placeholder="" />
                    </div>
                </el-col>
                <el-col :span="8" class="data-col">
                    <div class="label">会员积分</div>
                    <div class="value">
                        <el-input v-model="formData.score" placeholder="" />
                    </div>
                </el-col>
                <el-col :span="8" class="data-col">
                    <div class="label">会员欠款</div>
                    <div class="value">
                        <el-input v-model="formData.arrears" placeholder="" />
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="blank10"></div>
        <div class="change-box">
            <el-row type="flex" class="head">
                <el-col :span="24">调账说明</el-col>
            </el-row>
            <el-row type="flex" class="data">
                <el-col :span="24" class="data-col">
                    <el-input type="textarea" :autosize="{minRows: 4, maxRows: 10}" v-model="formData.remark" placeholder="" />
                </el-col>
            </el-row>
        </div>

        <div slot="foot" class="foot-box">
            <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;
            <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
        </div>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "StoreUserChangeMoney",
        components: {PopForm},
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [Number, String],
                default: ""
            }
        },
        data: () => ({
            storeUser: {},
            formData: {
                money: null,
                score: null,
                arrears: null,
                remark: ""
            },
        }),
        methods: {
            //获取用户信息
            getUserInfo: function () {
                if(obj.isEmpty(this.storeUid)) {
                    this.storeUser = {};
                    return false;
                }

                obj.postData("store_user/get_store_user_info", {id: this.storeUid}, res => {
                    if(res.errcode === 0){
                        res.data.store_uid = res.data.id;
                        this.storeUser = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            close: function () {
                this.$emit("stateChange", false);
            },
            cancelSave: function () {
                this.close();
            },
            submitSave: function () {
                let formData = {
                    store_uid: this.storeUid,
                    money: this.formData.money,
                    score: this.formData.score,
                    arrears: this.formData.arrears,
                    remark: this.formData.remark
                };
                obj.postData("store_user/change_user_money", formData, res => {
                    if(res.errcode === 0) {
                        obj.message.success("调账成功！");
                        this.$emit("changeEvent");
                        this.close();
                    }else
                        obj.message.error(res.errdesc);
                });
            },
        },
        watch: {
            state: function (val) {
                if(val) {
                    this.getUserInfo();
                    this.formData.remark = "";
                }
            },
            storeUser: function (val) {
                this.formData.money = val.money;
                this.formData.score = val.score;
                this.formData.arrears = val.arrears;
            }
        }
    }
</script>

<style scoped>
    .head{
        font-size: 14px;
        font-weight: bold;
        color: #909399;
        height: 40px;
        line-height: 40px;
        background-color: #f4f4f4;
        padding-left: 16px;
    }
    .data{
        font-size: 14px;
        color: #333333;
        line-height: 40px;
        padding-left: 16px;
    }
    .change-box .data-col{
        padding: 16px 0px;
        display: flex;
    }
    .change-box .label{
        display: inline-block;
        padding-left: 20px;
    }
    .change-box .value{
        display: inline-block;
        margin-left: 10px;
        flex: 1;
    }
    .foot-box{
        padding: 0px 16px 16px;
        text-align: right;
    }
</style>
